import { render, staticRenderFns } from "./ColourDisplayCpt.vue?vue&type=template&id=2e09ceee&scoped=true&"
import script from "./ColourDisplayCpt.vue?vue&type=script&lang=ts&"
export * from "./ColourDisplayCpt.vue?vue&type=script&lang=ts&"
import style0 from "./ColourDisplayCpt.vue?vue&type=style&index=0&id=2e09ceee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e09ceee",
  null
  
)

export default component.exports